// removed by extract-text-webpack-plugin
module.exports = {"trigger":"onfido-sdk-ui-Collapsible-trigger","isExpanded":"onfido-sdk-ui-Collapsible-isExpanded"};


//////////////////
// WEBPACK FOOTER
// ./components/Collapsible/style.css
// module id = 371
// module chunks = 1